import React from "react"
import moment from "moment"
import "./ClosedNotice.css"

export default function ClosedNotice({opensAt}) {
    const formatted = opensAt ? moment(opensAt).format("D. MMMM YYYY.") : null

    return <section className="closed-notice">
        <i className="fa-solid fa-lock"/>
        <h4>Prijave su trenutno zatvorene</h4>
        {formatted && <p>Otvaramo ih <strong>{formatted}</strong></p>}
    </section>
}
